import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PageHeaderComponent } from './page-header.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [PageHeaderComponent],
  imports: [CommonModule, FormsModule, TranslateModule, ContentEditableModule],
  exports: [PageHeaderComponent],
})
export class PageHeaderModule {}
